const JobStatus = {
    "Pending": 1,
    "Commenced Processing": 2,
    "Copy Design Completed": 3,
    "Models Generated": 4,
    "All Jobs Completed": 5,
    "Design Representations Generated": 6,
    "Failed": 7,
    "Job in Progress": 8,
    "Job Completed": 9,

    toString: (statusInt) => {
        switch (statusInt) {
            case 1: return "Pending";
            case 2: return "Commenced Processing";
            case 3: return "Copy Design Completed";
            case 4: return "Models Generated";
            case 5: return "All Jobs Completed";
            case 6: return "Design Representations Generated";
            case 7: return "Failed";
            case 8: return "Job in Progress";
            case 9: return "Job Completed";
            default: return "Unknown";
        }
    },

    toInt: (statusString) => {
        switch (statusString) {
            case "Pending": return 1;
            case "Commenced Processing": return 2;
            case "Copy Design Completed": return 3;
            case "Models Generated": return 4;
            case "All Jobs Completed": return 5;
            case "Design Representations Generated": return 6;
            case "Failed": return 7;
            case "Job in Progress": return 8;
            case "Job Completed": return 9;
            default: return -1;
        }
    }
};

export default JobStatus;